import { Point2D } from '../../../types';

/**
 * 渲染网格
 */
export function renderGrid(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  zoom: number,
  offset: Point2D
): void {
  const gridSize = 50; // 网格大小（世界坐标）
  const gridColor = '#e0e0e0';
  const axisColor = '#bdbdbd';

  ctx.save();

  // 计算可见区域的世界坐标范围
  const worldMinX = -offset.x / zoom;
  const worldMinY = -offset.y / zoom;
  const worldMaxX = (width - offset.x) / zoom;
  const worldMaxY = (height - offset.y) / zoom;

  // 对齐到网格
  const startX = Math.floor(worldMinX / gridSize) * gridSize;
  const startY = Math.floor(worldMinY / gridSize) * gridSize;
  const endX = Math.ceil(worldMaxX / gridSize) * gridSize;
  const endY = Math.ceil(worldMaxY / gridSize) * gridSize;

  // 绘制垂直线
  ctx.strokeStyle = gridColor;
  ctx.lineWidth = 1 / zoom;
  ctx.beginPath();
  for (let x = startX; x <= endX; x += gridSize) {
    ctx.moveTo(x, worldMinY);
    ctx.lineTo(x, worldMaxY);
  }
  ctx.stroke();

  // 绘制水平线
  ctx.beginPath();
  for (let y = startY; y <= endY; y += gridSize) {
    ctx.moveTo(worldMinX, y);
    ctx.lineTo(worldMaxX, y);
  }
  ctx.stroke();

  // 绘制坐标轴
  ctx.strokeStyle = axisColor;
  ctx.lineWidth = 2 / zoom;
  ctx.beginPath();
  // X轴
  ctx.moveTo(worldMinX, 0);
  ctx.lineTo(worldMaxX, 0);
  // Y轴
  ctx.moveTo(0, worldMinY);
  ctx.lineTo(0, worldMaxY);
  ctx.stroke();

  ctx.restore();
}
